module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var columns = widget.gridColumns(); 
    ; __append("\n")
    ;  var actions = widget.gridActions(); 
    ; __append("\n<tr>\n<!--<tr  on-click=\"onItemSelectClick\" >-->\n<!--<tr ")
    ; 	if(!(item.options && item.options.dictid)) { 
    ; __append(" on-click=\"onItemSelectClick\" ")
    ; }
    ; __append(">-->\n	")
    ;  Util.each(columns, function (column) { 
    ; __append("\n	<td on-click=\"onItemSelectClick\" class=\"gridview-column ")
    ; __append(escapeFn( column.styles ))
    ; __append("\" data-column-name=\"")
    ; __append(escapeFn( column.name ))
    ; __append("\">\n		")
    ; __append( widget.gridColumnContent(column, item) )
    ; __append("\n	</td>\n	")
    ;  }); 
    ; __append("\n		")
    ; 	if(item.options && item.options.dictid && !widget.disableChild) { 
    ; __append("\n			<td style=\"text-align: right;\">\n				<span on-click=\"onNextItemClick\" class=\"button icon-arrow-right next_item_btn\">\n                </span>\n			</td>\n		")
    ;  } 
    ; __append("\n	")
    ;  Util.each(actions, function (action) { 
    ; __append("\n	")
    ; 
		var enabled = true;

		if (Util.isDefined(action.enabled)) {
			if (Util.isFunction(action.enabled)) {
				enabled = !!action.enabled(item);
			} else {
				enabled = !!action.enabled;
			}
		}
    
    ; __append("\n	")
    ;  if (enabled) { 
    ; __append("\n	<td class=\"gridview__action\" ")
    ; __append( action["on-click"] ? 'on-click="' + action["on-click"] + '"' : '' )
    ; __append(" ")
    ; __append( action["name"] ? 'data-name="' + action["name"] + '"' : '' )
    ; __append(">\n		<div\n			class=\"icon-16 ")
    ; __append( action.css ? action.css : '' )
    ; __append("\"\n			")
    ; __append( action.title ? 'title="' + Html.encode(action.title) + '"' : '' )
    ; __append("\n			>\n			")
    ; __append(escapeFn( action.title && !action.css ? action.title : "" ))
    ; __append("\n		</div>\n	</td>\n	")
    ;  } else if (Util.isFunction(action.enabled)) { 
    ; __append("\n	<td class=\"gridview__action\">\n		<div>\n		</div>\n	</td>\n	")
    ;  } 
    ; __append("\n	")
    ;  }); 
    ; __append("\n</tr>\n")
  }
  return __output.join("");

}